import React from 'react';
import classnames from 'classnames';
import { TThumbnail } from '../UploadingFileThumbnail.types';
import styles from '../UploadingFileThumbnail.scss';

export const Picture: TThumbnail = ({ src, fallbackImageClassName, orientation }) => (
  <div
    className={classnames(styles.contentWrapper, styles.picture)}
    data-hook="uploading-file-thumbnail-picture"
    style={{
      display: orientation === null ? 'none' : undefined,
      transform:
        orientation && orientation.exif !== 0
          ? `scaleX(${orientation.scale.x}) scaleY(${orientation.scale.y}) rotate(${orientation.rotate}deg)`
          : undefined,
    }}
  >
    <div className={classnames(styles.fallback, fallbackImageClassName)} />
    <img className={classnames(styles.content, styles.fitSize)} src={src} />
  </div>
);
